/**
 * Ícone de PONTO DE ENCONTRO — pictograma "assembly point" (ISO 7010 E007).
 * Componente React (painel/legenda/popup). O desenho vem de `innerSvg` (fonte
 * única em `./assemblyPointSvg`, cor sanitizada lá, compartilhada com o marcador
 * Leaflet). Inline SVG (o projeto não tem lib de ícones; CSP-safe, sem asset externo).
 *
 * `aria-hidden`: em TODOS os usos o ícone acompanha texto equivalente ("Pontos de
 * encontro" / rótulo do PE) → decorativo, não anunciado por leitor de tela.
 */
import { innerSvg } from './assemblyPointSvg';

interface Props {
  size?: number;
  /** Cor do pictograma (setas + figuras). Default herda a cor do texto. */
  color?: string;
  className?: string;
}

export default function AssemblyPointIcon({ size = 18, color = 'currentColor', className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
      dangerouslySetInnerHTML={{ __html: innerSvg(color) }}
    />
  );
}
